const { createSlice } = require("@reduxjs/toolkit");
// const initialState = {
//   expensetype: [],
//   expensetype: null,
//     loading: false,
//     error: null,
// };
const initialState = {
  expensetypes: [],  // Liste des types de dépenses (pluriel)
  currentExpenseType: null, // Détail d'un type
  loading: false,
  error: null,
};

const expensetypeSlice = createSlice({
    name: "expensetypes",
    initialState,
    reducers: {
      setexpensetypesState: (state, { payload }) => {
            state.expensetypes = payload;
        },
        setexpensetypeState: (state, { payload }) => {
            state.expensetypes = payload;
        },
        setLoading: (state, { payload }) => {
            state.expensetypes = payload;
        },
        setError: (state, { payload }) => {
            state.error = payload;
        },
    },

});

export const { setexpensetypesState, setexpensetypeState, setLoading, setError } =
expensetypeSlice.actions;

export default expensetypeSlice.reducer;
